export default defineNuxtPlugin(() => {
  if (!window.vueRouter) window.vueRouter = useRouter()
})
